module.exports = __webpack_public_path__ + "static/media/02-1.9b32b8a6.png";